/**
 * <TutorPlatformFeedbackCard> — « Côté plateforme » : le masteur note son expérience du live (organism).
 *
 * L'écran d'aujourd'hui (`PlatformSatisfactionCard` + `LiveSatisfactionSection`) : la question,
 * « Indépendamment des élèves — visio, son, outils. », cinq étoiles ; une fois noté, les étiquettes
 * de cette note (les positives à 5 étoiles seulement, les négatives en dessous — c'est l'écran qui
 * les choisit) et le ressenti, à la voix ou par écrit (`<TutorCommentField>`, sans consigne).
 *
 * Contrôlée : la note, les étiquettes et le ressenti arrivent en props.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { Divider } from "../../atoms/Divider"
import { Text } from "../../atoms/typography/Text"
import { Card } from "../../molecules/Card"
import { LiveRating } from "../LiveRating"
import { TutorCommentField, type TutorCommentFieldProps } from "../TutorCommentField"
import { type UITutorPlatformFeedback } from "../../../ports/primary/ui/types/tutorCloseOut"

export type TutorPlatformFeedbackCardProps = Pick<
    TutorCommentFieldProps,
    | "onChangeMode"
    | "onChangeText"
    | "onRecordVoice"
    | "recorder"
    | "onDeleteVoice"
    | "onToggleVoicePlay"
    | "voicePlaying"
    | "voiceProgress"
    | "onRetry"
> & {
    feedback: UITutorPlatformFeedback
    onRate: (rating: number) => void
    onToggleTag: (tag: string) => void
    testID?: string
}

export function TutorPlatformFeedbackCard(props: TutorPlatformFeedbackCardProps) {
    const { feedback, onRate, onToggleTag, testID, ...commentHandlers } = props
    const rated = feedback.rating.rating > 0

    return (
        <Card p="4" testID={testID}>
            <Stack gap="4">
                <Stack gap="1" align="center">
                    <Text size="text-md" weight="bold" color="primary" center>
                        Qu&apos;as-tu pensé de ton expérience pendant ce live ?
                    </Text>
                    <Text size="text-sm" color="text-muted" center>
                        Indépendamment des élèves — visio, son, outils.
                    </Text>
                </Stack>
                <LiveRating
                    rating={rated ? feedback.rating.rating : null}
                    onRate={onRate}
                    comments={feedback.rating.tags}
                    selectedComments={feedback.rating.selectedTags}
                    onToggleComment={onToggleTag}
                />
                {rated && (
                    <>
                        <Divider />
                        <TutorCommentField
                            comment={feedback.comment}
                            placeholder="Ton ressenti sur la session..."
                            {...commentHandlers}
                        />
                    </>
                )}
            </Stack>
        </Card>
    )
}
